export default {
  "region": "eu-west-2",
  "darwin_halo_host_name": "app.xing-halo.sauce.construction",
  "darwin_user_pool_arn": "arn:aws:cognito-idp:eu-west-2:705297190372:userpool/eu-west-2_nYjquuliT",
  "darwin_user_pool_client_id": "1p0hv3pqvu330r7cd5938kpuap",
  "darwin_user_pool_endpoint": "cognito-idp.eu-west-2.amazonaws.com/eu-west-2_nYjquuliT",
  "darwin_user_pool_id": "eu-west-2_nYjquuliT",
  "diagnostics_api_endpoint": "https://3ruphh11g9.execute-api.eu-west-2.amazonaws.com/dev",
  "halo_api_endpoint": "https://a0zpsc9iej.execute-api.eu-west-2.amazonaws.com/dev",
  "halo_websocket_api_endpoint": "wss://fnci2y7x96.execute-api.eu-west-2.amazonaws.com/dev",
  "logic_iot_endpoint": "a1xlx4hts13knw-ats.iot.eu-west-2.amazonaws.com",
  "sentry_env": "dev"
} // 10/28/2026, 3:22:11 PM